
export default field_validator_args => {
  const default_message = '必須是一個陣列，並且陣列中的所有元素都必須滿足條件。'
  const { value, message = default_message, customArgs: custom_args } = field_validator_args

  if (Array.isArray(value)) {
    const { condition } = custom_args

    if (value.every(condition)) {
      return {
        succeeded: true,
        message: '',
        type: 'ARRAY_ELEMENTS_MATCH_CONDITION_VALIDATOR',
      }
    }
  }
  
  return {
    succeeded: false,
    message: message,
    type: 'ARRAY_ELEMENTS_MATCH_CONDITION_VALIDATOR',
  }
}
